import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { pluralize } from "@common/helpers/string";
import {
    TaskSummariesDiffValue,
    toTaskSummaries,
} from "./taskSummaryDiffHelpers";
import { TaskSummaryLinks } from "./TaskSummaryLinks";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskBlockedBy: React.FC<Props> = ({ log }) => {
    const diffEntry = log.diff.find((d) => d.field === "blockedByTasks");
    const before = toTaskSummaries(
        diffEntry?.before?.value as TaskSummariesDiffValue,
    );
    const after = toTaskSummaries(
        diffEntry?.after?.value as TaskSummariesDiffValue,
    );

    const beforeIds = new Set(before.map((t) => t.id));
    const afterIds = new Set(after.map((t) => t.id));
    const added = after.filter((t) => !beforeIds.has(t.id));
    const removed = before.filter((t) => !afterIds.has(t.id));

    const parts: React.ReactNode[] = [];
    if (removed.length > 0) {
        parts.push(
            <>
                removed {pluralize("blocker", removed.length)}{" "}
                <strong>
                    <TaskSummaryLinks summaries={removed} />
                </strong>
            </>,
        );
    }
    if (added.length > 0) {
        parts.push(
            <>
                added {pluralize("blocker", added.length)}{" "}
                <strong>
                    <TaskSummaryLinks summaries={added} />
                </strong>
            </>,
        );
    }

    if (parts.length === 0) {
        return (
            <span className={styles.chatTaskMessage}>
                changed blocked-by tasks
            </span>
        );
    }

    return (
        <span className={styles.chatTaskMessage}>
            {parts.reduce<React.ReactNode>(
                (acc, part, i) => (i === 0 ? part : [acc, " and ", part]),
                null,
            )}
        </span>
    );
};
